import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureCampaignAttribution, salsaAnalytics } from '../services/salsaAnalytics';

export function SalsaAnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    const loadAnalytics = () => {
      void salsaAnalytics.load();
    };

    loadAnalytics();
    window.addEventListener('onzoe-cookie-consent-changed', loadAnalytics);

    return () => {
      window.removeEventListener('onzoe-cookie-consent-changed', loadAnalytics);
    };
  }, []);

  useEffect(() => {
    const attribution = captureCampaignAttribution();
    salsaAnalytics.page({
      path: location.pathname,
      search: location.search,
      hash: location.hash,
      title: document.title,
      url: window.location.href,
      referrer: document.referrer || undefined,
      team_key: salsaAnalytics.config.teamKey,
      source: salsaAnalytics.config.source,
      ...attribution,
    });
  }, [location.hash, location.pathname, location.search]);

  return null;
}
